import * as React from "react";
import {observer} from "mobx-react";
import {Button} from "./Button";

@observer
export class SelectionButton extends Button {

  render() {
    return <Button {...this.props} >
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
          <path d="M28,4V28H4V4H28m4-4H0V32H32V0h0Z"/>
          <polygon points="15.33 25.12 6.1 18.2 7.9 15.8 14.67 20.88 23.78 8.13 26.22 9.87 15.33 25.12"/>
        </svg>
      </i>
    </Button>;
  }
}
